import { FC } from 'react'
import { observer } from 'mobx-react'
import { useStores } from '../../../utils'
import { IconButton } from '../../atoms/IconButton'
import MailIconSvg from '../../../public/images/common/mail_icon.svg'

type Props = {
  href: string
  isDisabled: boolean
  isSendabled: boolean
}

export const ProfileContactButton: FC<Props> = observer(({ href, isDisabled, isSendabled }) => {
  const { viewer, ui } = useStores()

  const openSetUpProfileToSendDMsModal = () => {
    ui.toggleSetUpProfileToSendDMsModal()
  }

  if (!isSendabled) {
    return (
      <IconButton disabled={viewer.isSignedIn ? isDisabled : false} onClick={openSetUpProfileToSendDMsModal}>
        <MailIconSvg />
      </IconButton>
    )
  }

  return (
    <IconButton
      componentType='a'
      href={viewer.isSignedIn ? href : '/signin'}
      disabled={viewer.isSignedIn ? isDisabled : false}
    >
      <MailIconSvg />
    </IconButton>
  )
})
